// v10.4 test Subgrid, make it nicer
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MapContainer, TileLayer, Marker, useMapEvents, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
// import GoogleMap from "./GoogleMap";
import { BrowserRouter, Route, Routes, Switch, Link } from "react-router-dom";
// Fix for default icon paths
import data from "./data";
import MarkerForm from "./MarkerForm";
import Upload from "./Upload";
import InstagramPostForm from './InstagramPostForm'; // Import the form
// import MarkerForm from "./MarkerForm";
import Header from "./Header";
import { AppContainer } from "../App.styles2";
import TripFetcher from "./Trip";
import { Subgrid } from "./Subgrid";

import { Carousel } from '@mantine/carousel';
import { Button, Paper, Text, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
// import classes from './CardsCarousel.module.css';
import { MantineProvider } from '@mantine/core';
// import { Button, Paper, Text, Title } from '@mantine/core';
import { Container, px, SimpleGrid, Skeleton, Stack } from '@mantine/core';
import { Card, Group, Image } from '@mantine/core';
import { IconStar } from '@tabler/icons-react';

import classes from './CarouselCard.module.css';

import MorderForm from "./MorderForm";
// import ABB from "./ABB";
import ABB from "./ABB_v2";
import ABB_MCU from "./ABB_v2 mcu";

import Page1 from "./Page1";
import { Fragment } from "react";
import Page2 from "./Page2";
import Page3 from "./Page3";
import PayPalPage from "./PayPalPage"

const theme = {
  // Customize the theme if required
  colorScheme: 'light', // Example: set light/dark theme
};


const icon =
  "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png";
const iconShadow =
  "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconAnchor: [12, 41], // Adjust anchor point to the bottom center of the icon
});

L.Marker.prototype.options.icon = DefaultIcon;

const center = {
  lat: 21.044175,
  lng: 105.846411,
};

// MinIO Configuration
const MINIO_ENDPOINT = "https://obj.tang17so82duytan.com";
const BUCKET_NAME = "demo-map";
const FILE_NAME = "location.json";



const stylesv1 = {
  container: {
    fontFamily: "'Nunito', sans-serif",
    padding: '25px',
    width: '300px',
    // width: '50wvw',
    margin: '40px auto',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.15)',
  },
  button: {
    width: '100%',
    padding: '12px 20px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    marginTop: '10px',
    fontFamily: "'Nunito', sans-serif",
  },
  textSection: {
    marginTop: '1rem',
    padding: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#f9f9f9',
    fontFamily: "'Nunito', sans-serif",
    fontSize: '16px',
  },
  description: {
    fontSize: '0.9rem',
    color: '#777',
    marginTop: '0',
    marginBottom: '15px',
    paddingLeft: '5px',
  },
};


const styles = {
  container: {
    fontFamily: "'Nunito', sans-serif",
    padding: '25px',
    width: '300px',
    margin: '40px auto',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.15)',
    // border: "2px solid rgba(0, 0, 0, 0.05)", /* thin shadow line */

  },
  button: {
    width: '100%',
    padding: '12px 20px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    marginTop: '10px',
    fontFamily: "'Nunito', sans-serif",
  },
  textSection: {
    marginTop: '1rem',
    padding: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    // backgroundColor: '#f9f9f9',
    fontFamily: "'Nunito', sans-serif",
    fontSize: '16px',
  },
  description: {
    fontSize: '0.9rem',
    color: '#777',
    marginTop: '0',
    marginBottom: '15px',
    paddingLeft: '5px',
    whiteSpace: 'pre-line'        // ← thêm dòng này

  },
  imageRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    overflowX: 'auto',          // ✅ Enable horizontal scroll
    paddingBottom: '10px',
  },
  image: {
    flex: '0 0 auto',           // ✅ Prevent images from shrinking
    width: '250px',             // Adjust width to fit your design
    borderRadius: '6px',
    objectFit: 'contain',
    overflow: 'auto'
  },


};


function ArticleCardImage() {
  return (
    <Paper shadow="md" p="xl" radius="md" className={classes.card}>
      <div>
        <Text className={classes.category} size="xs">
          nature
        </Text>
        <Title order={3} className={classes.title}>
          Best forests to visit in North America
        </Title>
      </div>
      <Button variant="white" color="dark">
        Read article
      </Button>
    </Paper>
  );
}

function myCard({ image, title, category }) {
  return (
    <Paper
      shadow="md"
      p="xl"
      radius="md"
      style={{ backgroundImage: `url(${image})` }}
      className={classes.card}
    >
      <div>
        <Text className={classes.category} size="xs">
          {category}
        </Text>
        <Title order={3} className={classes.title}>
          {title}
        </Title>
      </div>
      <Button variant="white" color="dark">
        Read article
      </Button>
    </Paper>
  );
}

const testData = [
  {
    image:
      'https://images.unsplash.com/photo-1508193638397-1c4234db14d8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80',
    title: 'Best forests to visit in North America',
    category: 'nature',
  },
  {
    image:
      'https://images.unsplash.com/photo-1559494007-9f5847c49d94?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80',
    title: 'Hawaii beaches review: better than you think',
    category: 'beach',
  },
  {
    image:
      'https://images.unsplash.com/photo-1608481337062-4093bf3ed404?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80',
    title: 'Mountains at night: 12 best locations to enjoy the view',
    category: 'nature',
  },
  {
    image:
      'https://images.unsplash.com/photo-1507272931001-fc06c17e4f43?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80',
    title: 'Aurora in Norway: when to visit for best experience',
    category: 'nature',
  },
  {
    image:
      'https://images.unsplash.com/photo-1510798831971-661eb04b3739?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80',
    title: 'Best places to visit this winter',
    category: 'tourism',
  },
  {
    image:
      'https://images.unsplash.com/photo-1582721478779-0ae163c05a60?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&q=80',
    title: 'Active volcanos reviews: travel at your own risk',
    category: 'nature',
  },
];

const images = [
  'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=720&q=80',
  'https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=720&q=80',
  'https://images.unsplash.com/photo-1605774337664-7a846e9cdf17?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=720&q=80',
  'https://images.unsplash.com/photo-1554995207-c18c203602cb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=720&q=80',
  'https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=720&q=80',
];
function CarouselCard() {
  const slides = images.map((image) => (
    <Carousel.Slide key={image}>
      <Image src={image} height={220} />
    </Carousel.Slide>
  ));

  return (
    <Card radius="md" withBorder padding="xl">
      <Card.Section>
        <Carousel
          withIndicators
          loop
          classNames={{
            root: classes.carousel,
            controls: classes.carouselControls,
            indicator: classes.carouselIndicator,
          }}
        >
          {slides}
        </Carousel>
      </Card.Section>

      <Group justify="space-between" mt="lg">
        <Text fw={500} fz="lg">
          Forde, Norway
        </Text>

        <Group gap={5}>
          <IconStar size={16} />
          <Text fz="xs" fw={500}>
            4.78
          </Text>
        </Group>
      </Group>

      <Text fz="sm" c="dimmed" mt="sm">
        Relax, rejuvenate and unplug in this unique contemporary Birdbox. Feel close to nature in
        ultimate comfort. Enjoy the view of the epic mountain range of Blegja and the Førdefjord.
      </Text>

      <Group justify="space-between" mt="md">
        <div>
          <Text fz="xl" span fw={500} className={classes.price}>
            397$
          </Text>
          <Text span fz="sm" c="dimmed">
            {' '}
            / night
          </Text>
        </div>

        <Button radius="md">Book now</Button>
      </Group>
    </Card>
  );
}

function CardsCarousel() {
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const slides = testData.map((item) => (
    <Carousel.Slide key={item.title}>
      <Card {...item} />
    </Carousel.Slide>
  ));

  return (
    <Carousel
      slideSize={{ base: '100%', sm: '50%' }}
      slideGap={{ base: 2, sm: 'xl' }}
      align="start"
      slidesToScroll={mobile ? 1 : 2}
    >
      {slides}
    </Carousel>
  );
}


const DraggableMarkerOld = ({ position, setPosition }) => {
  const markerRef = useRef(null);

  useMapEvents({
    dragend() {
      const marker = markerRef.current;
      if (marker != null) {
        setPosition(marker.getLatLng());
      }
    },
  });

  return <Marker draggable position={position} ref={markerRef} />;
};

const DraggableMarkerOld2 = ({ position, setPosition }) => {
  const markerRef = useRef(null);
  const [currentCoords, setCurrentCoords] = useState(position);

  useMapEvents({
    dragend() {
      const marker = markerRef.current;
      if (marker != null) {
        const newPosition = marker.getLatLng();
        setPosition(newPosition);
        setCurrentCoords(newPosition); // Update the current coordinates

        // Log current location
        // console.log("####### current ##########");
        // console.log(`Current Location: Latitude: ${newPosition.lat}, Longitude: ${newPosition.lng}`);
      }
    },
  });

  return (
    <Marker draggable position={position} ref={markerRef}>
      <Popup>
        Latitude: {currentCoords.lat}<br />
        Longitude: {currentCoords.lng}
      </Popup>
    </Marker>
  );
};

const DraggableMarker = ({ position, setPosition }) => {
  const markerRef = useRef(null);

  useMapEvents({
    dragend() {
      const marker = markerRef.current;
      if (marker != null) {
        const newPosition = marker.getLatLng();
        setPosition(newPosition);
        console.log("Marker dragged to: ", newPosition); // Log the new position
      }
    },
  });

  return (
    <Marker
      draggable
      position={position}
      ref={markerRef}
      eventHandlers={{
        dragend: () => {
          const marker = markerRef.current;
          if (marker) {
            const newPosition = marker.getLatLng();
            setPosition(newPosition);
            console.log("Marker dragged to: ", newPosition); // Log the new position
            console.log(marker)
            console.log("###### marker ref ###")
            console.log(markerRef)

          }
        },
      }}
    >
      <Popup>
        Latitude: {position.lat}<br />
        Longitude: {position.lng}
      </Popup>
    </Marker>
  );
};

function OldToggleTextSection() {
  // Track whether the section is visible
  const [isOpen, setIsOpen] = useState(false);

  // Toggle visibility on click
  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <div style={{ maxWidth: 400, margin: '1rem auto', textAlign: 'center' }}>
      <button
        onClick={handleToggle}
        style={{
          padding: '0.5rem 1rem',
          cursor: 'pointer',
          background: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: 4
        }}
      >
        {isOpen ? 'Hide Guides' : 'Show Guides'}
      </button>

      {isOpen && (
        <div
          className="text-section"
          style={{
            marginTop: '1rem',
            padding: '1rem',
            border: '1px solid #ccc',
            borderRadius: 4,
            background: '#f9f9f9'
          }}
        >
          <p>
            This is the detailed text that appears when the button is clicked.
            You can put any content here—paragraphs, images, lists, whatever you need.
          </p>
        </div>
      )}
    </div>
  );
}

function Old2ToggleTextSection() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(prev => !prev);

  return (
    <div style={styles.container}>
      <button
        style={styles.button}
        onClick={handleToggle}
      >
        {isOpen ? 'Hide Guides' : 'Show Guides'}
      </button>

      {isOpen && (
        <div style={styles.textSection}>
          <p style={styles.description}>
            This is the detailed text that appears when the button is clicked.
            You can put any content here—paragraphs, images, lists, whatever you need.
          </p>
        </div>
      )}
    </div>
  );
}

function ToggleTextSectionv1() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(prev => !prev);

  const draft_styles = {
    container: {
      padding: '1rem',
      fontFamily: 'Arial, sans-serif',
    },
    button: {
      padding: '0.5rem 1rem',
      fontSize: '1rem',
      cursor: 'pointer',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
    },
    textSection: {
      marginTop: '1rem',
    },
    description: {
      marginBottom: '1rem',
    },
    imageRow: {
      display: 'flex',
      gap: '1rem',
      flexWrap: 'wrap',
    },
    image: {
      maxWidth: '100%',
      height: 'auto',
      width: '300px', // adjust as needed
      borderRadius: '8px',
    },
  };

  return (
    <div style={styles.container}>
      <button style={styles.button} onClick={handleToggle}>
        {isOpen ? 'Hide Guides' : 'Show Guides'}
      </button>

      {isOpen && (
        <div style={styles.textSection}>
          <p style={styles.description}>
            This is the detailed text that appears when the button is clicked.
            You can put any content here—paragraphs, images, lists, whatever you need.
          </p>
          <div style={styles.imageRow}>
            <img
              src="https://obj.tang17so82duytan.com/demo-map/guide%202.gif"
              alt="Guide GIF"
              style={styles.image}
            />
            <img
              src="https://obj.tang17so82duytan.com/demo-map/Screenshot_20250601_122653_Telegram-1749576811962.jpg"
              alt="Telegram Screenshot"
              style={styles.image}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function ToggleTextSection() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(prev => !prev);

  return (
    <div style={styles.container}>
      <button style={styles.button} onClick={handleToggle}>
        {isOpen ? 'Hide Guides' : 'Show Guides'}
      </button>

      {isOpen && (
        <div style={styles.textSection}>
          <p style={styles.description}>
            {`1. Tạo tài khoản và login | Create account and login
            2. Chọn Source Image | Choose Source Image
            3. Chọn Target Image | Choose Target Image
            4. Ấn Submit/ Click Submit
            5. Kiểm tra kết quả bằng cách ấn Vỉew Results, ấn lại sau vài giây/phút/giờ, tùy thuộc vào ảnh/độ dài video/tải hiện tại | To check the results, click “View Results,” then click again after a few seconds, minutes, or even hours, depending on the image/video length and current load.`}
          </p>
          <div style={styles.imageRow}>

            <img
              src="https://obj.tang17so82duytan.com/demo-map/Screenshot_20250601_122653_Telegram-1749576811962.jpg"
              alt="Telegram Screenshot"
              style={styles.image}
            />
            <img
              src="https://obj.tang17so82duytan.com/demo-map/guide v2.3.gif
"
              alt="Guide GIF"
              style={styles.image}
            />

          </div>
        </div>
      )}
    </div>
  );
}

function ToggleTextSectionMarker() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(prev => !prev);

  return (
    <div style={styles.container}>
      <button style={styles.button} onClick={handleToggle}>
        {isOpen ? 'Hide Guides' : 'Show Guides'}
      </button>

      {isOpen && (
        <div style={styles.textSection}>
          <p style={styles.description}>
            {`1. Comming soon
              2. 
            `}
          </p>
          <div style={styles.imageRow}>

            {/* <img
              src="https://obj.tang17so82duytan.com/demo-map/Screenshot_20250601_122653_Telegram-1749576811962.jpg"
              alt="Telegram Screenshot"
              style={styles.image}
            />
            <img
              src="https://obj.tang17so82duytan.com/demo-map/guide v2.3.gif
"
              alt="Guide GIF"
              style={styles.image}
            /> */}

          </div>
        </div>
      )}
    </div>
  );
}

function ToggleTextSectionPost() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(prev => !prev);

  return (
    <div style={styles.container}>
      <button style={styles.button} onClick={handleToggle}>
        {isOpen ? 'Hide Guides' : 'Show Guides'}
      </button>

      {isOpen && (
        <div style={styles.textSection}>
          <p style={styles.description}>
            {`1. Comming soon
              2. 
            `}
          </p>
          <div style={styles.imageRow}>

            {/* <img
              src="https://obj.tang17so82duytan.com/demo-map/Screenshot_20250601_122653_Telegram-1749576811962.jpg"
              alt="Telegram Screenshot"
              style={styles.image}
            />
            <img
              src="https://obj.tang17so82duytan.com/demo-map/guide v2.3.gif
"
              alt="Guide GIF"
              style={styles.image}
            /> */}

          </div>
        </div>
      )}
    </div>
  );
}

function ToggleTextSectionTrip() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(prev => !prev);

  return (
    <div style={styles.container}>
      <button style={styles.button} onClick={handleToggle}>
        {isOpen ? 'Hide Guides' : 'Show Guides'}
      </button>

      {isOpen && (
        <div style={styles.textSection}>
          <p style={styles.description}>
            {`1. Comming soon
              2. 
            `}
          </p>
          <div style={styles.imageRow}>

            {/* <img
              src="https://obj.tang17so82duytan.com/demo-map/Screenshot_20250601_122653_Telegram-1749576811962.jpg"
              alt="Telegram Screenshot"
              style={styles.image}
            />
            <img
              src="https://obj.tang17so82duytan.com/demo-map/guide v2.3.gif
"
              alt="Guide GIF"
              style={styles.image}
            /> */}

          </div>
        </div>
      )}
    </div>
  );
}

const SubMapComponent = () => {
  const [activeTab, setActiveTab] = useState('marker');
  const [showDropdown, setShowDropdown] = useState(false);
  const [markerPosition, setMarkerPosition] = useState(center);
  const [notes, setNotes] = useState("");
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const mapRef = useRef(null);

  // Location search state
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const searchTimeoutRef = useRef(null);

  // Search location using Nominatim API
  const searchLocation = async (query) => {
    if (!query || query.trim().length < 2) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=5`,
        {
          headers: {
            'Accept': 'application/json',
            'User-Agent': 'MapApplication/1.0' // Required by Nominatim usage policy
          }
        }
      );

      if (!response.ok) {
        throw new Error('Search failed');
      }

      const data = await response.json();
      setSearchResults(data);
      setShowSearchResults(data.length > 0);
    } catch (error) {
      console.error("Error searching location:", error);
      setSearchResults([]);
      setShowSearchResults(false);
    } finally {
      setIsSearching(false);
    }
  };

  // Debounced search - triggers after user stops typing
  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set new timeout for debounced search
    searchTimeoutRef.current = setTimeout(() => {
      searchLocation(value);
    }, 500); // Wait 500ms after user stops typing
  };

  // Handle selecting a location from search results
  const handleSelectLocation = (result) => {
    const newLocation = {
      lat: parseFloat(result.lat),
      lng: parseFloat(result.lon)
    };

    setMarkerPosition(newLocation);
    setSearchQuery(result.display_name);
    setShowSearchResults(false);
    setSearchResults([]);

    if (mapRef.current) {
      mapRef.current.setView(newLocation, 15); // Zoom level 15 for selected location
    }

    console.log("Location selected:", result.display_name, newLocation);
  };

  // Handle search button click
  const handleSearchButtonClick = () => {
    if (searchResults.length > 0) {
      // If there are results, select the first one
      handleSelectLocation(searchResults[0]);
    } else {
      // Otherwise, trigger a new search
      searchLocation(searchQuery);
    }
  };

  // Handle Enter key press in search input
  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchButtonClick();
    } else if (e.key === 'Escape') {
      setShowSearchResults(false);
    }
  };

  // Close search results when clicking outside
  const handleClickOutside = () => {
    setShowSearchResults(false);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Update the map view whenever the marker position changes
  useEffect(() => {
    console.log("###### MapComp potition update ########")
    console.log(markerPosition)
    console.log("###### MapComp useEffect ########")
    console.log(mapRef.current)
    if (mapRef.current) {
      mapRef.current.setView(markerPosition, 13); // Update map view to new position
    }
  }, [markerPosition]);

  // Move the marker to the current geolocation
  // This will request permission every time the button is clicked
  const moveMarkerToCurrentLocation = async () => {
    // Check if geolocation is supported
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser. Please use a modern browser.");
      return;
    }

    // For browsers that support the Permissions API, check permission state
    if (navigator.permissions) {
      try {
        const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });

        if (permissionStatus.state === 'denied') {
          alert(
            "Location access was denied. To enable it:\n\n" +
            "📱 On iPhone/iPad:\n" +
            "• Tap the 'AA' button in Safari's address bar\n" +
            "• Tap 'Website Settings' > Location > Allow\n\n" +
            "📱 On Android:\n" +
            "• Tap the lock/info icon in the address bar\n" +
            "• Tap 'Permissions' > Location > Allow\n\n" +
            "💻 On Desktop:\n" +
            "• Click the lock icon in the address bar\n" +
            "• Find Location and select 'Allow'"
          );
          return;
        }
      } catch (error) {
        // Permissions API not supported, continue with regular request
        console.log("Permissions API not available, proceeding with geolocation request");
      }
    }

    // Request current position - this will trigger permission dialog if not yet granted
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        console.log("Geolocation Success:", `Latitude: ${latitude}, Longitude: ${longitude}`);
        const newLocation = { lat: latitude, lng: longitude };
        setMarkerPosition(newLocation); // Update marker position
        if (mapRef.current) {
          mapRef.current.setView(newLocation, 13); // Center the map view
        }
      },
      (error) => {
        console.error("Geolocation Error:", error);
        let message = "Error retrieving location. ";

        switch (error.code) {
          case error.PERMISSION_DENIED:
            message += "Location access was denied. To enable it:\n\n" +
              "📱 iPhone/iPad: Tap 'AA' in address bar > Website Settings > Location > Allow\n" +
              "📱 Android: Tap lock icon > Permissions > Location > Allow\n" +
              "💻 Desktop: Click lock icon in address bar > Location > Allow";
            break;
          case error.POSITION_UNAVAILABLE:
            message += "Location information is unavailable. Please check your device's location services.";
            break;
          case error.TIMEOUT:
            message += "Location request timed out. Please try again.";
            break;
          default:
            message += "An unknown error occurred. Please make sure location services are enabled.";
        }

        alert(message);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0 // Always get fresh location, no caching
      }
    );
  };

  // Handle file input changes
  const handleFileChange = (event, setFile) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  // Upload file to the MinIO bucket
  const uploadFile = async (file, type) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `https://obj.tang17so82duytan.com/demo-map/${type}/${file.name}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return `https://obj.tang17so82duytan.com/demo-map/${type}/${file.name}`;
    } catch (error) {
      console.error(`Error uploading ${type}:`, error);
      throw error;
    }
  };

  // Save the current location and other data
  const saveLocation = async () => {
    try {
      let existingData = { locations: [] };

      try {
        const response = await axios.get(
          "https://obj.tang17so82duytan.com/demo-map/location.json"
        );
        existingData = response.data;
      } catch (fetchError) {
        if (fetchError.response && fetchError.response.status === 404) {
          console.warn("File does not exist. Creating new file with empty data.");
        } else {
          throw fetchError;
        }
      }

      let locations = existingData.locations || [];

      const roundCoordinates = (coord) => ({
        lat: Math.round(coord.lat * 1e6) / 1e6,
        lng: Math.round(coord.lng * 1e6) / 1e6,
      });

      console.log("Current locations:", locations);

      const isDuplicate = locations.some((loc) => {
        const locCoords = loc.position || {};
        const markerCoords = markerPosition || {};
        if (
          !locCoords.lat ||
          !locCoords.lng ||
          !markerCoords.lat ||
          !markerCoords.lng
        ) {
          console.error("Invalid coordinates found. Skipping duplicate check.");
          return false;
        }
        return (
          roundCoordinates(locCoords).lat ===
          roundCoordinates(markerCoords).lat &&
          roundCoordinates(locCoords).lng === roundCoordinates(markerCoords).lng
        );
      });

      if (!isDuplicate) {
        const locationData = {
          position: markerPosition,
          notes: notes,
          imageUrl: null,
          videoUrl: null,
        };

        if (image) {
          try {
            locationData.imageUrl = await uploadFile(image, "images");
          } catch (uploadError) {
            console.error("Error uploading image:", uploadError);
          }
        }

        if (video) {
          try {
            locationData.videoUrl = await uploadFile(video, "videos");
          } catch (uploadError) {
            console.error("Error uploading video:", uploadError);
          }
        }

        locations.push(locationData);

        const updatedData = JSON.stringify({ locations });

        try {
          await axios.put(
            "https://obj.tang17so82duytan.com/demo-map/location.json",
            updatedData,
            {
              headers: { "Content-Type": "application/json" },
            }
          );
          console.log("Location saved successfully:", updatedData);
          alert("Location saved successfully!");
        } catch (uploadError) {
          console.error("Error updating JSON file:", uploadError);
          alert("Error updating location data.");
        }
      } else {
        alert("This location has already been saved.");
      }
    } catch (error) {
      console.error("Error saving location:", error);
      alert("Error saving location.");
    }
  };

  const buttonStyle = {
    backgroundColor: '#007bff',  // Button color
    color: 'white',  // Text color
    padding: '12px 20px',  // Padding
    fontSize: '16px',  // Font size
    fontWeight: '600',  // Bold text
    borderRadius: '5px',  // Rounded corners
    border: 'none',  // No border
    cursor: 'pointer',  // Pointer cursor on hover
    transition: 'background-color 0.3s ease, transform 0.2s ease',  // Smooth transitions
    boxShadow: '0 4px 10px rgba(0, 123, 255, 0.3)',  // Subtle shadow

  };


  return (
    <div>
      <AppContainer>
        <Header />
        {/* Navigation Bar */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-around',
          padding: '5px 0',
          borderBottom: '1px solid #e0e0e055',
          backgroundColor: '#fefefe', // Match handle background
          // position: 'sticky', // Make nav sticky below handle
          // position: 'relative', 
          // top: '48px', // Position below the handle (adjust if handle height changes)
          // marginTop: '48px',
          zIndex: 9, // Below handle, above content
          // margin: '2px',
        }}>


          {/* Marker icon */}
          <svg
            viewBox="0 0 24 24"
            width="32"
            height="32"
            fill="none"
            stroke={activeTab === 'marker' ? 'black' : '#999'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ cursor: 'pointer' }}
            onClick={() => handleTabClick('marker')}
          >
            <g transform="scale(1, 1.07)" transform-origin="center">
              <path d="M12 6C7 6 4 9 4 12c0 3.5 4.5 7.5 8 9.5 3.5-2 8-6 8-9.5 0-3-3-6-8-6z" />
              <circle cx="12" cy="12.5" r="3.2" />
            </g>
          </svg>

          {/* Simple Human Face Icon */}
          <svg
            viewBox="0 0 24 30"
            width="24"
            height="34"
            fill="none"
            stroke={activeTab === 'profile' ? 'black' : '#999'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ cursor: 'pointer' }}
            onClick={() => handleTabClick('profile')}
          >
            <g transform="translate(0, -2)">
              <circle cx="12" cy="19" r="10" />
              <circle cx="8" cy="17" r="1" fill={activeTab === 'profile' ? 'black' : '#999'} stroke="none" />
              <circle cx="16" cy="17" r="1" fill={activeTab === 'profile' ? 'black' : '#999'} stroke="none" />
              <path d="M8 23c1.333 1.333 4.667 1.333 6 0" />
            </g>
          </svg>


          {/* Post icon */}
          <svg
            viewBox="0 0 24 30"
            width="28"
            height="32"
            fill="none"
            stroke={activeTab === 'post' ? 'black' : '#999'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ cursor: 'pointer' }}
            onClick={() => handleTabClick('post')}
          >
            <g transform="translate(0, 5)">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <path d="M12 8v8M8 12h8" />
            </g>
          </svg>

          {/* Trip icon */}
          <svg
            viewBox="0 0 24 24"
            width="32"
            height="32"
            fill="none"
            // stroke="#999"
            stroke={activeTab === 'trip' ? 'black' : '#999'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ cursor: 'pointer' }}
            onClick={() => handleTabClick('trip')}
          >
            <g transform="translate(0, 1)">
              <rect x="5" y="7" width="14" height="12" rx="2" ry="2" />
              <path d="M9 7V5a3 3 0 0 1 6 0v2" />
              <line x1="12" y1="7" x2="12" y2="19" />
            </g>
          </svg>

          {/* Heart + Plus Icon (Replacing Likes Heart) */}
          <div
            onClick={() => handleTabClick('likes')}
            style={{
              background: 'none',
              border: 'none',
              padding: '5px 10px',
              cursor: 'pointer',
              color: activeTab === 'likes' ? 'black' : '#999',
              position: 'relative',
              display: 'inline-block',
              display: 'none',
            }}
          >
            {/* Heart SVG */}
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ display: 'block' }}
            >
              <path d="M20.8 4.6c-1.5-1.4-3.9-1.4-5.4 0L12 8l-3.4-3.4c-1.5-1.4-3.9-1.4-5.4 0-1.5 1.5-1.5 3.9 0 5.4l8.8 8.8 8.8-8.8c1.5-1.5 1.5-3.9 0-5.4z" />
            </svg>
            {/* Plus sign right against the heart */}
            <svg
              viewBox="0 0 24 24"
              width="11"
              height="11"
              fill="none"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{
                position: 'absolute',
                top: '1px',
                right: '4px',
                pointerEvents: 'none',
              }}
            >
              <line x1="5" y1="12" x2="19" y2="12" /> {/* Horizontal */}
              <line x1="12" y1="5" x2="12" y2="19" /> {/* Vertical */}
            </svg>
          </div>
        </div>

        {activeTab === 'profile' && (
          // <Page1/>
          <div
            style={{
              height: '200dvh',
              display: 'flex',
              flexDirection: 'column',
              overflow: "auto"
            }}
          >
            {/* <p>Simple Text Section</p>
            <div style={{ position: 'relative' }}>
              <button onClick={() => setShowDropdown(!showDropdown)}>
                {showDropdown ? '&#9650;' : '&#9660;'}
              </button>
              {showDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  padding: '10px',
                  zIndex: 1,
                }}>
                  Dropdown Content
                </div>
              )}
            </div> */}
            <ToggleTextSection />

            <MorderForm />
            <br />
            <br />
            <br />

          </div>
          // <div>Reels Content Here</div> // Placeholder
        )}

        {activeTab === 'marker' && (
          // <Page2/>
          <div
            style={{
              height: '300dvh',
              display: 'flex',
              flexDirection: 'column',
              overflow: "auto"
            }}
          >

            <ToggleTextSectionMarker />

            <MapContainer
              center={markerPosition}
              zoom={13}
              style={{
                height: "400px",
                width: "100%",
                borderRadius: "10px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                border: "1px solid #ddd",
                overflow: "hidden",
              }}
              whenCreated={(mapInstance) => {
                mapRef.current = mapInstance; // Initialize map reference
              }}
              ref={mapRef}
            >
              <TileLayer
                // old OSM look
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'

                // Carto looks better, gemini gpt give this answer
                // failed url="https://{s}.basemaps.cartocdn.com/rastertiles/positron/{z}/{x}/{y}{r}.png"
                // failed url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_matter/{z}/{x}/{y}{r}.png"
                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
              />

              <DraggableMarker position={markerPosition} setPosition={setMarkerPosition} />
            </MapContainer>

            <div style={{ marginTop: "10px" }}>
              <button
                onClick={moveMarkerToCurrentLocation}
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  marginRight: "10px",
                  fontFamily: "'Nunito', sans-serif",
                }}
              >
                Di chuyển đến vị trí hiện tại
              </button>
            </div>

            {/* Location Search Section */}
            <div style={{
              marginTop: "0px",
              position: "relative",
              fontFamily: "'Nunito', sans-serif",
            }}>
              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: "8px",
                alignItems: "center",
                width: "100%",
                boxSizing: "border-box", // Ensure padding doesn't overflow width
              }}>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  onKeyDown={handleSearchKeyDown}
                  onFocus={() => searchResults.length > 0 && setShowSearchResults(true)}
                  placeholder="Tìm kiếm địa điểm..."
                  style={{
                    width: "100%",
                    minWidth: 0,
                    padding: "8px 12px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                    fontSize: "14px",
                    fontFamily: "'Nunito', sans-serif",
                    outline: "none",
                    color: "#333",
                    backgroundColor: "#fff",
                    boxSizing: "border-box",
                    height: "36px", // Fixed height for consistency
                  }}
                />
                <button
                  onClick={handleSearchButtonClick}
                  disabled={isSearching || !searchQuery.trim()}
                  style={{
                    width: "auto",
                    height: "36px", // Match input height
                    minWidth: "40px",
                    backgroundColor: isSearching ? "#6c757d" : "#28a745",
                    color: "white",
                    padding: "0 12px", // Horizontal padding only
                    borderRadius: "5px",
                    border: "none",
                    cursor: isSearching || !searchQuery.trim() ? "not-allowed" : "pointer",
                    fontFamily: "'Nunito', sans-serif",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {isSearching ? "..." : "🔍"}
                </button>
              </div>

              {/* Search Results Dropdown */}
              {showSearchResults && searchResults.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    zIndex: 1000,
                    maxHeight: "250px",
                    overflowY: "auto",
                    marginTop: "4px",
                  }}
                >
                  {searchResults.map((result, index) => (
                    <div
                      key={result.place_id || index}
                      onClick={() => handleSelectLocation(result)}
                      style={{
                        padding: "12px 14px",
                        cursor: "pointer",
                        borderBottom: index < searchResults.length - 1 ? "1px solid #eee" : "none",
                        transition: "background-color 0.15s ease",
                        fontSize: "14px",
                        lineHeight: "1.4",
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = "#f0f7ff"}
                      onMouseOut={(e) => e.target.style.backgroundColor = "#fff"}
                    >
                      <div style={{
                        fontWeight: "500",
                        color: "#333",
                        marginBottom: "2px",
                      }}>
                        {result.display_name.split(',')[0]}
                      </div>
                      <div style={{
                        fontSize: "12px",
                        color: "#666",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}>
                        {result.display_name.split(',').slice(1).join(',')}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Close dropdown when clicking outside */}
              {showSearchResults && (
                <div
                  onClick={handleClickOutside}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999,
                  }}
                />
              )}
            </div>

            {/* Add CSS animation for loading spinner */}
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>

            <MarkerForm lat={markerPosition.lat} lon={markerPosition.lng} />

          </div>
          // <div>Reels Content Here</div> // Placeholder
        )}

        {activeTab === 'post' && (
          // <Page1/>
          <div
            style={{
              height: '200vh',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'auto'
            }}
          >
            <ToggleTextSectionPost />

            <h3 style={{
              textAlign: 'center',
              marginBottom: '2px',
              fontSize: '1.4rem',
              fontWeight: 'bold',
              color: '#000',
              paddingLeft: '5px',
              fontWeight: '800',
              WebkitTextStroke: '1px black',
            }}>
              Create Posts
            </h3>
            <InstagramPostForm lat={25} lon={0} />

          </div>

          // <div>Reels Content Here</div> // Placeholder
        )}

        {activeTab === 'trip' && (
          // <Page2/>
          <div
            style={{
              height: '200vh',
              display: 'flex',
              flexDirection: 'column',
              verflow: 'auto'
            }}
          >
            {/* <PayPalPage/> */}
            <ToggleTextSectionTrip />

            <TripFetcher />

          </div>
          //            marginTop: '48px',


          // <div>Reels Content Here</div> // Placeholder
        )}


        {/* <ABB/>
        <ABB_MCU/> */}


        {/* Pass coordinates to the form */}
      </AppContainer>
    </div>
  );
};



const Home2 = () => {
  return (
    <div>
      <h2>Welcome to the Map Application!</h2>
      <p>This application allows you to find and save locations on a map.</p>
      <p>Navigate to the "Add Marker" page to start adding your locations!</p>
    </div>
  );
};

const MapComponent = () => {
  // const data = await response.json();

  const [properties, setProperties] = useState(data.properties);
  const [DefaultCenter] = useState(data.properties[0]);
  const [activeProperty, setActiveProperty] = useState(data.properties[0]);
  return (
    <SubMapComponent />
    // <BrowserRouter>
    //   <Routes>
    //     {/* fix GG component */}
    //     {/* <Route path="/" element={<GoogleMap DefaultCenter={DefaultCenter} />} /> */}
    //     <Route path="/current" element={<SubMapComponent />} />
    //   </Routes>
    // </BrowserRouter>
  );
};
export default MapComponent;
